import API from '../../../services/api.svelte.js';
import { notificate } from '../../../services/notification.js';
import vulnerabilityService from '../service.js';
import { CVSS } from "@turingpointde/cvss.js";



// store Promise to avoid multiple simultaneous API calls
let customsPromise;
let customs = [];
let updated_at = null;

export function search(config = {}) {
    customsPromise = API.search('v2/vulnerability/custom/', config)
        .catch(() => {
            return Promise.resolve([]);
        })
        .then(pCustoms => {
            customs = pCustoms;
            updated_at = new Date();
            return customs;
        })
    ;

    return customsPromise;
}

export function find(id, config = {}) {
    let custom;
    let customPromise = API.find('custom', id, config)
        .catch(() => {
            return Promise.resolve([]);
        })
        .then(pcustom => {
            custom = pcustom;
            return custom;
        })
    ;
    return customPromise;
}

export function save(data, files = [], config = {}) {
    return API.save(!data.id ? 'v2/vulnerability/custom': 'v2/vulnerability/custom', data, files, config)
        .then(async (response) => {
            if (!response.ok) {
                let errors = await response.json();
                // api validation errors
                if(response.status == 401){

                    notificate('limitReached')
                }
                else {

                    let toastConfig = {
                        data: data.title,
                        id  : data.id,
                        options : {
                            "timeOut": "0",
                            "extendedTimeOut": "0",
                            "showDuration": "0",
                            "hideDuration": "0",
                            "closeButton": true
                        }

                    }
                    if(response.status == 422){
                        if(errors.detail == 'Invalid CVSS3 vector') notificate('cvss_vector_error', "toast", toastConfig);
                        if(errors.detail == 'The CWE does not exist on the database') notificate('cwe_invalid', "toast", toastConfig);
                    }

                    if(config && config.massive_addition) toastConfig.error = errors;
                    notificate('save_error', "toast", toastConfig);
                }
                throw errors;
            }
            return response.json();
        })
        .then(apiData => {
            notificate('save_ok', "toast", {data: apiData.title_es || apiData.title});
            vulnerabilityService.updateCache(apiData, true);
            return apiData;
        })
    ;
}

export function del(custom, config = {}) {
    return API.del('v2/vulnerability/custom', custom.id, config)
        .then(async (response) => {
            if (!response.ok) {
                // api validation errors
                notificate('delete_error', "toast", {data: custom.title});
                let errors = await response.json();
                throw errors;
            }
            return response.json();
        })
        .then(data => {
            notificate('delete_ok', "toast", {data: custom.title_es || custom.title});
            vulnerabilityService.updateCache(apiData, false);
            return customs;
        })
    ;
}

export function getCVSSscore(vector){
    vector = CVSS(vector)
    return vector.getScore();
}

export function getCVSStemporalScore(vector){
    return vector.getTemporalScore();
}


export async function updateFromVDB(config={}){
    return API.taskExecute('workspace/update-vdb', config).then(response => response);
}

export function uploadVRF(data = {}, files = [], config= {}){
    return API.save('v2/vrf', data, [],  config);
}

export default {
    search,
    find,
    save,
    del,
    getCVSSscore,
    getCVSStemporalScore,
    updateFromVDB,
    uploadVRF
}